<template>
<div class="lvBeforeBox">
<!--  直播标题-->
  <lvTitle :baseInfo="baseInfo" liveState="未开始"></lvTitle>
<!--  预约按钮: 是否已经预约-->

<!--  苹果端-->
  <div v-if="appSys==2">
    <div class="btnAppointment" @click="orderBtn_ios">{{ orderStr }}</div>
  </div>
<!--  安卓端-->
  <div v-else>
    <div v-if="isWechat">
<!--      <div class="btnAppointment" @click="orderBtn_and">{{ orderStr }}</div>-->
      <div class="btnAppointment">{{ orderStr }}
        <wx-open-launch-app
            id="launch-btn"
            appid="wxec933f097079480f"
            :extinfo="extinfo"
            @launch="launch"
            @error="error"
            style="position:absolute;top:0;left:0;right:0;bottom:0; overflow: hidden"
        >
          <script type="text/wxtag-template">
            <style>.btn {width: 600px; height: 200px;}</style>
            <div class="btn"></div>
          </script>
        </wx-open-launch-app>
      </div>
    </div>
    <div v-else>
      <div class="btnAppointment" @click="orderBtn_and">{{ orderStr }}</div>
    </div>
  </div>

<!--  已经预约头像-->
  <lvAppointmentUser :liveId="baseInfo.id" :orderNum="baseInfo.orderNum"></lvAppointmentUser>
<!--  直播简介-->
  <lvIntroduction :baseInfo="baseInfo"></lvIntroduction>
</div>
</template>

<script>
import lvTitle from "./lvTitle";
import {apiLive} from "../../../network/app/apiPlatformLive";
import lvAppointmentUser from "./lvAppointmentUser";
import lvIntroduction from "./lvIntroduction";
import {Toast} from "vant";
import {baseConfig} from "../../../network/baseConfig";
import {openLaunchInit, shareWXInit} from "../../../js/activity/share";
import {browser} from "../../../js/browser";

export default {
  name: "lvBefore",
  props: {
    baseInfo: {
      type: Object,
      required: true
    },
    isOrder: {type: Number, required: true}
  },
  data(){
    return {
      orderStr: "立即预约",
      myIsOrder: this.isOrder,
      extinfo: 'platformLive',
      appSys: 0, //1=android 2=ios
      isWechat: false, //是否为微信
    }
  },
  watch:{
    isOrder:{
      handler(newval, oldval){
        this.myIsOrder = newval
        // // console.log("lvBefore watch==========")
        // if(newval==1){
        //   this.orderStr = "已预约"
        // }else{
        //   this.orderStr = "立即预约"
        // }
      }
    },
    myIsOrder:{
      handler(newval, oldval){
        console.log("lvBefore watch======myIsOrder===="+newval)
        if(newval==1){
          this.orderStr = "已预约"
        }else{
          this.orderStr = "立即预约"
        }
      }
    },
  },
  components:{
    lvTitle,
    lvAppointmentUser,
    lvIntroduction
  },
  created() {

    // var browser = {
    //   versions: function() {
    //     var u = navigator.userAgent, app = navigator.appVersion;
    //     return {
    //       trident: u.indexOf('Trident') > -1, //IE内核
    //       presto: u.indexOf('Presto') > -1, //opera内核
    //       webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
    //       gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
    //       mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
    //       ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    //       android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
    //       iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
    //       iPad: u.indexOf('iPad') > -1, //是否iPad
    //       webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
    //     };
    //   }(),
    //   language: (navigator.browserLanguage || navigator.language).toLowerCase()
    // }
    //
    // // alert(JSON.stringify(browser))
    // if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
    //   //如果是ios系统
    //   // alert("是ios系统")
    //   this.appSys = 2
    // }
    // else if (browser.versions.android) {
    //   //如果是Android系统 就
    //   // alert("是Android系统")
    //   this.appSys = 1
    // }
    // var ua = navigator.userAgent.toLowerCase();
    // if(ua.match(/MicroMessenger/i)=="micromessenger") {
    //   // console.log('这是微信')
    //   // alert("这是微信")
    //   this.isWechat = true
    // } else {
    //   // console.log('这是微信')
    //   // alert("不是微信")
    //   this.isWechat = false
    // }

    this.appSys = browser.getAppSys()
    this.isWechat = browser.getIsWechat()


    // console.log("lvBefore create")

    // shareWXInit(baseInfo.title,
    //     // baseInfo.synopsis,
    //     "直播时间：2022年5月19日9：00-16：30 敬请收看！",
    //     baseConfig.makeShareUrl('live/202205190900'),
    //     baseInfo.img)
    let openlunchObj = {
      'platformLive': this.baseInfo.id.toString()    }
    this.extinfo = JSON.stringify(openlunchObj)
    // alert(this.extinfo)
  },
  mounted() {

  },
  methods:{
    launch(){
      // alert("launch")
    },
    error(){
      // alert("error")
      //未安装应用，会到这里
      this.orderBtn()

    },
    orderBtn_ios(){
      // alert("ios")
      this.orderBtn()
      window.location.href = 'https://act-web.toodo.com.cn/popularization?platformLive='+this.baseInfo.id

      return
    },
    orderBtn_and(){
      // alert("and web")
      this.orderBtn()
      window.location.href = 'toodo://com.toodo.app/popularization?platformLive='+this.baseInfo.id

      return
    },
    orderBtn(){
      console.log('打开APP')
      setTimeout(()=>{
        window.location.href = baseConfig.getAppInfo().href
      }, 100)

      return

      let obj = {
        'id': this.baseInfo.id,
        'verify': (this.myIsOrder==1)?0:1
      }
      console.log(obj)
      apiLive.orderPlatformLive(obj).then(res=>{
        console.log(res)
        this.myIsOrder = res.isOrder
        if(this.myIsOrder==1){
          Toast({
            message: '预约成功',
            position: 'bottom',
          });
        }else{
          Toast({
            message: '取消预约',
            position: 'bottom',
          });
        }
        // console.log("是否已经预约： "+this.isOrder)
      }).catch(err=>{

      })
    }
  }
}
</script>

<style scoped>
.lvBeforeBox{
  margin-top: 40px;
  width: 100%;
  /*height: 50px;*/
  /*background-color: #96acb4;*/
}
.btnAppointment{
  position: relative;
  width: 100%;
  height: 160px;
  background-color: #009bff;
  color: whitesmoke;
  text-align: center;
  line-height: 160px;
  font-size: 50px;
  font-weight: bolder;
  border-radius: 20px;
  letter-spacing:8px;
  margin-bottom: 30px;
  overflow: hidden;
}
.bankOff{
  width: 100%;
  height: 140px;
  background-color: #07c160;
}
</style>